import crc8dvbs2 from './calculators/crc8dvbs2.js';
import defineCrc from './define_crc.js';
export default defineCrc('crc-8-dvbs2', crc8dvbs2);
